<template>
  <li
    :class="[
      tw`[grid-row:span_2] [grid-column:span_2]`,
      tw`md:[grid-row:initial] md:[grid-column:initial]`,
    ]"
  >
    <RevButtonBase
      v-if="!static"
      ref="interactiveElement"
      class="block h-full w-auto"
      :class="[
        itemSizeClass,
        {
          'focus-visible-outline-inset-hi cursor-pointer':
            props.allowMediaViewer,
        },
      ]"
      @click="onClick"
      @focusin.passive="onEnter"
      @focusout.passive="onLeave"
      @mouseenter.passive="onEnter"
      @mouseleave.passive="onLeave"
    >
      <slot />
    </RevButtonBase>
    <div v-else class="block h-full w-auto">
      <slot />
    </div>
  </li>
</template>

<script setup lang="ts">
import { RevButtonBase } from '@ds/components/ButtonBase'
import { tw } from '@ds/utils/tailwind'

const props = withDefaults(
  defineProps<{
    index: number
    allowMediaViewer: boolean
    static?: boolean
    itemSizeClass?: string
  }>(),
  {
    static: false,
    itemSizeClass: '',
  },
)

const emit = defineEmits<{
  (e: 'click', index: number): void
  (e: 'enter', index: number): void
  (e: 'leave', index: number): void
}>()

const onClick = () => {
  emit('click', props.index)
}

const onEnter = () => {
  emit('enter', props.index)
}

const onLeave = () => {
  emit('leave', props.index)
}
</script>
